import { render, staticRenderFns } from "./hi-select.vue?vue&type=template&id=8287c7a4"
import script from "./hi-select.vue?vue&type=script&lang=ts"
export * from "./hi-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports